function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, reactive, toRefs, openBlock, createElementBlock, normalizeClass, unref, normalizeStyle, createVNode, withCtx, createElementVNode, toDisplayString } from 'vue';
import { ElTooltip } from '../../tooltip/index.mjs';
import '../../../hooks/index.mjs';
import './composables/index.mjs';
import { sliderButtonProps, sliderButtonEmits } from './button.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
import { useSliderButton } from './composables/use-slider-button.mjs';
const _hoisted_1 = ["tabindex"];
const __default__ = defineComponent({
  name: "ElSliderButton"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: sliderButtonProps,
  emits: sliderButtonEmits,
  setup(__props, _ref) {
    let expose = _ref.expose,
      emit = _ref.emit;
    const props = __props;
    const ns = useNamespace("slider");
    const initData = reactive({
      hovering: false,
      dragging: false,
      isClick: false,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: 0,
      oldValue: props.modelValue
    });
    const _useSliderButton = useSliderButton(props, initData, emit),
      disabled = _useSliderButton.disabled,
      button = _useSliderButton.button,
      tooltip = _useSliderButton.tooltip,
      showTooltip = _useSliderButton.showTooltip,
      tooltipVisible = _useSliderButton.tooltipVisible,
      wrapperStyle = _useSliderButton.wrapperStyle,
      formatValue = _useSliderButton.formatValue,
      handleMouseEnter = _useSliderButton.handleMouseEnter,
      handleMouseLeave = _useSliderButton.handleMouseLeave,
      onButtonDown = _useSliderButton.onButtonDown,
      onKeyDown = _useSliderButton.onKeyDown,
      setPosition = _useSliderButton.setPosition;
    const _toRefs = toRefs(initData),
      hovering = _toRefs.hovering,
      dragging = _toRefs.dragging;
    expose({
      onButtonDown,
      onKeyDown,
      setPosition,
      hovering,
      dragging
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "button",
        ref: button,
        class: normalizeClass([unref(ns).e("button-wrapper"), {
          hover: unref(hovering),
          dragging: unref(dragging)
        }]),
        style: normalizeStyle(unref(wrapperStyle)),
        tabindex: unref(disabled) ? -1 : 0,
        onMouseenter: _cache[0] || (_cache[0] = function () {
          return unref(handleMouseEnter) && unref(handleMouseEnter)(...arguments);
        }),
        onMouseleave: _cache[1] || (_cache[1] = function () {
          return unref(handleMouseLeave) && unref(handleMouseLeave)(...arguments);
        }),
        onMousedown: _cache[2] || (_cache[2] = function () {
          return unref(onButtonDown) && unref(onButtonDown)(...arguments);
        }),
        onTouchstart: _cache[3] || (_cache[3] = function () {
          return unref(onButtonDown) && unref(onButtonDown)(...arguments);
        }),
        onFocus: _cache[4] || (_cache[4] = function () {
          return unref(handleMouseEnter) && unref(handleMouseEnter)(...arguments);
        }),
        onBlur: _cache[5] || (_cache[5] = function () {
          return unref(handleMouseLeave) && unref(handleMouseLeave)(...arguments);
        }),
        onKeydown: _cache[6] || (_cache[6] = function () {
          return unref(onKeyDown) && unref(onKeyDown)(...arguments);
        })
      }, [createVNode(unref(ElTooltip), {
        ref_key: "tooltip",
        ref: tooltip,
        visible: unref(tooltipVisible),
        placement: _ctx.placement,
        "fallback-placements": ["top", "bottom", "right", "left"],
        "stop-popper-mouse-event": false,
        "popper-class": _ctx.tooltipClass,
        disabled: !unref(showTooltip),
        persistent: ""
      }, {
        content: withCtx(() => [createElementVNode("span", null, toDisplayString(unref(formatValue)), 1)]),
        default: withCtx(() => [createElementVNode("div", {
          class: normalizeClass([unref(ns).e("button"), {
            hover: unref(hovering),
            dragging: unref(dragging)
          }])
        }, null, 2)]),
        _: 1
      }, 8, ["visible", "placement", "popper-class", "disabled"])], 46, _hoisted_1);
    };
  }
}));
var SliderButton = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "button.vue"]]);
export { SliderButton as default };